import React from 'react';
import classNames from 'classnames';

import './HomeHeroBanner.scss';

const HomeHeroBanner = props => {
  const { data = {} } = props;
  const {
    title,
    subtitle,
    alignment,
    backgroundColor,
    backgroundImage,
    textColor,
    isDarkText,
    removeTopPadding,
    removeBottomPadding,
    addBottomBorder,
    functionalHeader,
    functionalSubheader,
    titleHeaderTag,
    subtitleHeaderTag
  } = data;

  const inlineStyle = {
    backgroundColor: backgroundColor,
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : null,
    color: textColor
  };

  const HeaderElement = titleHeaderTag ? titleHeaderTag : 'h1';
  const SubHeaderElement = subtitleHeaderTag ? subtitleHeaderTag : 'h2';

  return (
    <div
      className={classNames({
        'container-fluid': true,
        'home-hero-banner': true,
        'yellow-border': addBottomBorder === true
      })}
      style={inlineStyle}
    >
      <div className="container">
        <div
          className={classNames({
            row: true,
            'pt-5': removeTopPadding !== true,
            'pb-5': removeBottomPadding !== true,
            'pt-0': removeTopPadding === true,
            'pb-0': removeBottomPadding === true
          })}
        >
          <div
            className={classNames({
              'col-md-12': true,
              'px-0 py-4': true,
              'text-left': alignment === 'left',
              'text-center': alignment === 'center',
              'text-right': alignment === 'right',
              'dark-text': isDarkText === true
            })}
          >
            {functionalHeader === true ? (
              <HeaderElement>{title}</HeaderElement>
            ) : (
              <div className={HeaderElement}>{title}</div>
            )}
            {functionalSubheader === true ? (
              <SubHeaderElement>{subtitle}</SubHeaderElement>
            ) : (
              <div className={SubHeaderElement}>{subtitle}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeHeroBanner;
